export const navItems = [
    { name: "HOME", path: "/" },
    { name: "PROJECTS", path: "/projects" },
    { name: "SKILLS", path: "/skills" },
    { name: "CONTACT", path: "/contact" },
    { name: "BADGDE", path:"/badge"}
  ];